<template>
  <div
    style="
      display: flex;
      flex-direction: row;
      align-items: center;
      border: 1px solid #d9e4f8;
      text-align: left;
    "
  >
    <div
      style="
        margin: 20px 0px 20px 30px;
        width: 200px;
        font-size: 14px;
        color: #0f1a3a;
      "
    >
      {{ config.title }}
    </div>
    <div style="flex: 1; font-size: 12px; color: #0f1a3a">
      <kl-icon style="color: #ff8c00" :size="14" icon="icon-icon_prompt2" />
      {{ config.desc }}
    </div>
    <div
      v-if="config.showCount"
      style="font-size: 12px; color: #0f1a3a; margin-right: 80px"
    >
      {{$t('speedlimit.Seted')}}<span
        style="
          font-size: 16px;
          width: 60px;
          text-align: center;
          display: inline-block;
          color: #2a7aff;
          font-weight: bold;
        "
        >{{ config.count }}</span
      >{{$t('speedlimit.Seted1')}}
    </div>
    <div style="margin-right: 28px">
      <el-button type="primary" @click="onClick" plain size="small"
        >{{$t('speedlimit.Set')}}</el-button
      >
    </div>
  </div>
</template>
<script>
export default {
  props: {
    config: {
      type: Object,
      default: {
        title: "",
        desc: "",
        count: "",
        click: undefined,
        showCount: true,
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    onClick() {
      if (this.config.click) this.config.click();
    },
  },
};
</script>
